(function () {
 
  function getPct() {
    const bar = document.querySelector('.fo-availability-xline__bar[aria-valuenow]');
    if (bar) return parseInt(bar.getAttribute('aria-valuenow'), 10);
    const text = document.querySelector('#locationNamesContainer')?.innerText || '';
    const match = text.match(/(\d+)%/);
    return match ? parseInt(match[1], 10) : null;
  }
 
  function update() {
    const container = document.querySelector('#locationNamesContainer');
    if (!container) return false;
    const pct = getPct();
    if (pct === null) return false;
 
    container.classList.remove('av--green', 'av--blue', 'av--orange', 'av--red');
    let prefix;
    if (pct >= 70) {
      container.classList.add('av--green');
      prefix = 'Aktuell';
    } else if (pct >= 40) {
      container.classList.add('av--blue');
      prefix = 'Noch';
    } else if (pct >= 15) {
      container.classList.add('av--orange');
      prefix = 'Nur noch';
    } else {
      container.classList.add('av--red');
      prefix = 'Nur noch begrenzt';
    }
 
    const statusEl = container.querySelector('.fo-availability-xline__status');
    if (statusEl) {
      const newText = prefix + ' <strong>' + pct + '%</strong> verfügbar';
      if (statusEl.innerHTML !== newText) statusEl.innerHTML = newText;
    }
 
    return true;
  }
 
  function tryUpdate(attempts) {
    if (attempts <= 0) return;
    if (!update()) setTimeout(() => tryUpdate(attempts - 1), 400);
  }
 
  let debounce;
  function debouncedUpdate() {
    clearTimeout(debounce);
    debounce = setTimeout(update, 150);
  }
 
  const appContainer = document.querySelector('.multiloca-availability-container');
  if (appContainer) {
    new MutationObserver((mutations) => {
      const relevant = mutations.some(m => {
        // Attribut-Änderung am Balken
        if (m.type === 'attributes' && m.attributeName === 'aria-valuenow') return true;
        // Neue Nodes (Standort wurde neu gerendert)
        if (m.type === 'childList' && m.addedNodes.length > 0) return true;
        // Ignoriere Text-Änderungen die wir selbst gemacht haben
        return false;
      });
      if (relevant) debouncedUpdate();
    }).observe(appContainer, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-valuenow']
    });
  }
 
  window.addEventListener('storage', e => {
    if (e.key === 'selected_location' || e.key === 'fw_location') setTimeout(update, 300);
  });
 
  setTimeout(() => tryUpdate(10), 300);
 
})();